export default "__VITE_ASSET__C64GYXHH__";